import {
  MainButton,
  Typography,
  TypographySize,
  TypographyWeight,
} from "@beydesign/storybook"
import { Box, Divider } from "@mui/material"
import React from "react"

export function DisableMobile() {
  const handleGetStarted = () => {
    window.open(
      "https://docs.bey.dev/get-started/",
      "_blank",
      "noopener,noreferrer",
    )
  }

  return (
    <Box
      width={"100%"}
      height={"100vh"}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      sx={{
        backgroundImage: "url(/background.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      padding={"var(--spacing-tokens-size-in-px-spacing-spacing-xl)"}
    >
      <Box
        bgcolor={"var(--colors-light-background-bg-white)"}
        padding={"var(--spacing-tokens-size-in-px-spacing-spacing-xl)"}
        paddingBottom={"var(--spacing-tokens-size-in-px-spacing-spacing-3xl)"}
        borderRadius={"var(--spacing-tokens-size-in-px-radius-radius-md)"}
        boxShadow={"var(--shadow-tokens-shadow-shadow-sm)"}
        display={"flex"}
        flexDirection={"column"}
        gap={"var(--spacing-tokens-size-in-px-spacing-spacing-xl)"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <img
          src="/bp_logo.svg"
          alt="Beyond Presence Logo"
          style={{ width: "50px", height: "auto" }}
        />
        <Typography
          size={TypographySize.HeadingM}
          weight={TypographyWeight.SemiBold}
          textStyle={{ textAlign: "center" }}
        >
          To use Beyond Presence, go to a Desktop version
        </Typography>
        <Divider sx={{ width: "100%" }} />
        <Typography
          size={TypographySize.TextS}
          weight={TypographyWeight.Medium}
          textStyle={{ textAlign: "center" }}
        >
          Beyond Presence is only available on Desktop. You can continue to our
          docs to learn more about our platform.
        </Typography>
        <MainButton
          text="Get Started"
          style={{ width: "100%" }}
          onClick={handleGetStarted}
        />
      </Box>
    </Box>
  )
}
